{
  "top-salons-city-page": {
    "text": {
      "no-salon-found": "Chưa tìm thấy salon nào tại thành phố này."
    },
    "meta": {
      "title": "Salon hàng đầu tại {{ city }}",
      "description": "Khám phá và đặt lịch tại những salon làm đẹp được đánh giá cao nhất ở {{ city }}. So sánh các salon hàng đầu, kiểm tra lịch trống và đặt lịch hẹn trực tuyến chỉ trong vài phút."
    }
  }
}
